module.exports = __webpack_public_path__ + "cdba23ccc5014ba4b67128788427b6c0.png";